/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ThumbsDownRegular from './thumbs-down-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ThumbsDownRegular {...validProps} />;
}
SvgComponent.iconName = 'thumbs-down-regular';

export const ThumbsDownRegularIcon = svgIconWrapper(SvgComponent);
